const getSnapshotOfState = (state, result) => {
    let leftArtwork = Object.assign({}, state.currentArtwork.leftArtwork);
    let rightArtwork = Object.assign({}, state.currentArtwork.rightArtwork);
    let leftCustom = Object.assign({}, state.customLayer.leftArtwork);
    let rightCustom = Object.assign({}, state.customLayer.rightArtwork);
    if ('both' in result) {
        leftArtwork.leftImage = result.both;
        leftArtwork.rightImage = result.both;
        leftCustom.src = result.both;
        rightArtwork.leftImage = result.both;
        rightArtwork.rightImage = result.both;
        rightCustom.src = result.both;
    }
    if ('left_artwork' in result) {
        leftArtwork.leftImage = result['left_artwork'];
        leftArtwork.rightImage = result['left_artwork'];
        leftCustom.src = result['left_artwork'];
    }
    if ('right_artwork' in result) {
        rightArtwork.rightImage = result['right_artwork'];
        rightArtwork.leftImage = result['right_artwork'];
        rightCustom.src = result['right_artwork'];
    }
    return {
        currentArtwork: {
            leftArtwork: leftArtwork,
            rightArtwork: rightArtwork
        },
        currentModel: state.currentModel,
        currentFaceplateOption: state.currentFaceplateOption,
        currentShell: state.currentShell,
        currentCableOption: state.currentCableOption,
        finalizeForm: {
            ...state.finalizeForm
        },
        iemPrice: state.iemPrice,
        customLayer: {
            leftArtwork: leftCustom,
            rightArtwork: rightCustom
        },
        preview: { url: result.preview }
    };
};

export default getSnapshotOfState;
